<template>
  <advanced-search />
</template>

<script>
import AdvancedSearch from "@/components/AdvancedSearch";

export default {
  components: {
    AdvancedSearch
  }
};
</script>